<template>
  <van-overlay :show="showCompositeCard" @click="show = false" :lock-scroll="false">
    <div class="wrapper" @click.stop>
      <div class="wrapper-content">
        <img class="compose-bg" src="@/assets/images/activity/collect-cards/compose-bg.png" alt="">
        <div class="wrapper-body">
          <p class="wrapper-title">成功合成{{countCoupon}}次卡牌</p>
          <p class="wrapper-title">恭喜您获得以下卡券！</p>
          <p class="wrapper-subtitle">请在“我的卡券”中查看</p>
          <div class="collect-coupon">
            <ActivityCollectCardsCoupon :award-list="list" :style-type="'mini'" :height="'70px'" :showCount="true"></ActivityCollectCardsCoupon>
          </div>
          <!-- <p class="wrapper-text" v-if="hasPointCoupon">积分券已为您兑换，请尽快使用</p> -->
        </div>
        <div class="wrapper-footer" >
          <van-button class="button-cancel" @click="close" round :style="{ width : userRole !== '03'? '50%' :'100%'}">我知道了</van-button>
          <van-button class="button-confirm" @click="jumpCoupon" round v-if="userRole !== '03'">我的卡券</van-button>
        </div>
      </div>
    </div>
  </van-overlay>
</template>

<script>
import ActivityCollectCardsCoupon from './activity-collectCards-coupon.vue'
export default {
  components: {
    ActivityCollectCardsCoupon
  },
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      showCompositeCard: false,
      userRole: ''
    }
  },
  computed: {
    hasPointCoupon () {
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].itemCode === '0') {
          return true
        }
      }
      return false
    },
    countCoupon () {
      return this.list.reduce((pre, item) => {
        return pre + item.count
      }, 0)
    }
  },
  mounted () {
    this.userRole = JSON.parse(localStorage.getItem('userInfo')).clientInfo.clientUserDTO.userRole
  },
  methods: {
    open () {
      this.showCompositeCard = true
    },
    close () {
      this.showCompositeCard = false
      this.$emit('after-close')
    },
    jumpCoupon () {
      this.$router.push({ name: 'userCoupon' })
    }

  }
}
</script>
<style lang='less' scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;

  .wrapper-content {
    position: relative;
    width: 70vw;
    background-color: #fff;
    text-align: center;
    box-sizing: border-box;
    border-radius: 10px;
    border: none;

    .wrapper-body {
      padding: 15px;
      max-height: 50vh;
      overflow-x: hidden;
      overflow-y: auto;

    }

    .wrapper-title {
      font-size: 18px;
      line-height: 25px;
      font-weight: 700;
    }

    .wrapper-subtitle {
      font-size: 12px;
      color: #666666;
      margin: 10px 0px;
    }

    .wrapper-text {
      color: #666666;
      font-size: 10px;
      margin-top: 10px;
    }

    .wrapper-footer {
      padding: 15px;

      display: flex;
      align-items: center;
      justify-content: space-between;

      .button-cancel {
        color: #5696A0;
        border-color: #5696A0;
        font-size: 16px;
      }

      .button-confirm {
        color: #fff;
        border-color: #5696A0;
        background-color: #5696A0;
        font-size: 16px;
      }

      .van-button {
        width: 48%;
      }
    }
  }

  .compose-bg {
    width: 100%;
    position: absolute;
    top: -120px;
    left: 0px;
    z-index: 9999;
  }
}

</style>
